// @owners { team: patients-team }
import { BORDERS, COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, H1, MdSpacing, Row, useScreenSize } from '@alto/design-system';
import { useQueryEssentialsFeeConfigs } from '@alto/features';
import React from 'react';
import styled from 'styled-components';
import { type Shipment } from '~shared/types';
import { useSidePadding } from './useSidePadding';
import { Image } from '~web/features/essentials/primitives';

const StyledHeaderContainer = styled.div<{ isSMScreenOrBigger: boolean; sidePadding: string }>`
  display: flex;
  flex-direction: column;
  padding: ${({ isSMScreenOrBigger, sidePadding }) =>
    `${!isSMScreenOrBigger ? SPACING.STATIC.XL.px : SPACING.STATIC.XXXL.px} ${SPACING.STATIC.XL.px} ${
      !isSMScreenOrBigger ? SPACING.STATIC.NONE.px : SPACING.STATIC.XXXL.px
    } ${sidePadding}`};
  ${({ isSMScreenOrBigger }) =>
    !isSMScreenOrBigger && `background-color: ${COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTEST};`}
  ${({ isSMScreenOrBigger }) => isSMScreenOrBigger && `flex: 1; min-height: 0;`}
  border-bottom: solid ${COLORS.BORDER_COLORS.LIGHT} ${BORDERS.SIZE}px;
  ${({ isSMScreenOrBigger }) => isSMScreenOrBigger && `border-bottom: none;`}
`;

type Props = {
  readonly shipment: Shipment | undefined;
  readonly children: React.ReactNode;
};

export const StoreHeaderWrapper = ({ shipment, children }: Props) => {
  const { isSMScreenOrBigger } = useScreenSize();
  const sidePadding = useSidePadding();
  const { essentialsFreeDeliveryText } = useQueryEssentialsFeeConfigs();

  return (
    <StyledHeaderContainer
      isSMScreenOrBigger={isSMScreenOrBigger}
      sidePadding={sidePadding}
    >
      <Row centerVertically>
        <H1>{shipment ? 'Add ' : 'Shop '}</H1>
        <Image
          src="https://assets.prod.alto.com/otc_categories/essentials_logo.svg"
          alt="add essentials to your delivery"
        />
      </Row>
      {shipment ? <H1>to your delivery</H1> : null}
      {!shipment && (
        <>
          <MdSpacing />
          <Body color={COLORS.TEXT_COLORS.GREY}>{essentialsFreeDeliveryText}</Body>
        </>
      )}
      {children}
    </StyledHeaderContainer>
  );
};
